import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M19.4142 20.4142V10.4142H6.82843L9.82843 13.4142L8.41421 14.8284L3 9.41421L8.41421 4L9.82843 5.41421L6.82843 8.41421H21.4142V20.4142H19.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerUpLeft;
